module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAA5UlEQVQ4ja2TMQrCQBBFn5ITCBY5gRAEG208RBob0WvoDSwEG2uxDB7AygvYpYggwcIivWAltt/CDcTVJRr8MCzzZ+exO8uCJUlLlWtp99Vto6r+B5LkS4okJZLCbxsljU1PJMn3gC3QNfXGD4doAh0TLa8AybUBkhJICvQLebcmSQVjD5y/PFEA9PLEBlXW317Ns/LKV7NBa56DDEog+bBfQDGvLzcChsDJAWkDEZAVvNgDQmBhNlxNIQHmDtDMrBfgAByB6dsu82lvkjJH3D99WntGuXbAxFFbfTJdoIEJl1LbeADkD4txhXH6rAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/general-icons/icono_print.png
// module id = 605
// module chunks = 0